export default function EmptyStateView({ onCreateKey }: { onCreateKey: () => void }) {
  return (
    <div className="container-element">
      <h3 className="fw-bold mb-4">Existing Keys</h3>
      <div
        className="d-flex flex-column align-items-center justify-content-center flex-grow-1"
        style={{ minHeight: 'calc(80vh - 100px)' }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-circle mb-5"
          style={{ background: 'var(--bs-primary-500)', width: 180, height: 180 }}
        >
          <img src="/keys.svg" alt="Keys Icon" width={80} height={80} />
        </div>
        <div className="text-center text-sm mb-5">
          Hey! It seams you don't have any key created yet
        </div>
        <button className="btn btn-outline-secondary" onClick={onCreateKey}>
          Create Key
        </button>
      </div>
    </div>
  );
}
